// client/src/components/UploadForm.jsx
import React, { useState } from "react";
import ImagePicker from "./ImagePicker";
import LoadingOverlay from "./LoadingOverlay";
import { useNavigate } from "react-router-dom";
import { submitAnalysis } from "../api/submit";

const UploadForm = () => {
  //Test za LoadingOverlay.jsx
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    age: "",
    image: null,
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const handleImagePick = (file) => {
    setForm((p) => ({ ...p, image: file }));
  };

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!form.image) {
      setMsg("Priložite crtež.");
      return;
    }

    setLoading(true);
    try {
      // ⏳ TEST DELAY (5–10 sekundi)
      const fakeDelay = Math.random() * 5000 + 5000; // 5000–10000ms
      await sleep(fakeDelay);

      const result = await submitAnalysis({
        name: form.name,
        surname: form.surname,
        email: form.email,
        phone: form.phone,
        age: form.age,
        file: form.image,
      });

      // === Routing po statusu iz backend-a ===
      if (result.status === "limit_reached") {
        navigate("/info", {
          state: {
            title: "Iskorišćene su sve analize",
            message: result.message || "Prekoračen je broj dozvoljenih preuzimanja.",
            limit: result.limit,
            generatedCount: result.generatedCount,
          },
        });
        return;
      }

      if (result.status === "pending_confirmation") {
        navigate("/info", {
          state: {
            title: "Potvrdite prijavu",
            message: result.message || "Proverite email i potvrdite prijavu.",
          },
        });
        return;
      }

      if (result.status === "ready") {
        navigate("/delivery", {
          state: {
            pdfLink: result.pdfLink,
            remaining: result.remaining,
            generatedCount: result.generatedCount,
          },
        });
        return;
      }

      if (result.status === "interspire_unavailable") {
        setMsg("Sistem za verifikaciju je privremeno nedostupan. Pokušajte kasnije.");
        return;
      }

      // fallback error
      setMsg("Došlo je do greške. Pokušajte ponovo.");
    } catch (err) {
      setMsg(err?.message || "Neuspješno slanje. Pokušajte ponovo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {loading && (
      <LoadingOverlay text="Pepper analizira crtež…" />
    )}
    <form method="post" onSubmit={handleSubmit}>
      <h2 className="form-heading">Pošaljite Pepperu crtež:</h2>
      {msg && <div className="notice">{msg}</div>}

      <input className="field" type="text" name="name" placeholder="Ime deteta" onChange={handleChange} required />
      <input className="field" type="text" name="surname" placeholder="Prezime deteta" onChange={handleChange} required />
      <input className="field" type="number" name="age" placeholder="Godine deteta" onChange={handleChange} required min={0} max={12} />
      <input className="field" type="email" name="email" placeholder="Email roditelja" onChange={handleChange} required />
      <input className="field" type="tel" name="phone" placeholder="Tel: +381651234567" onChange={handleChange} required />
      {/* <input className="field" type="file" name="image" accept="image/*" onChange={handleChange} required /> */}
      <ImagePicker onPick={handleImagePick} />
      <button type="submit" disabled={loading}>
        {loading ? "Slanje..." : "Pošalji"}
      </button>
    </form>
    </>
  );
};

export default UploadForm;
